export default __webpack_public_path__ + "static/media/1-desk.aa1c20a0.jpg";